module.exports = __webpack_public_path__ + "static/media/cursor5.9717620c.svg";